import { FilterSection } from 'components/shared/filters/FilterSlideout';
import {
  HAS_NEW_CHANGES_CHECKBOX,
  PLAN_TYPE_DROPDOWN,
  REFERRAL_STATUS_DROPDOWN,
  REFERRED_BY_DROPDOWN,
  REFERRED_TO_DROPDOWN,
} from 'constants/filterConfigs';

export function getFilterSections(): FilterSection[] {
  return [
    {
      title: 'Filters',
      filters: [
        PLAN_TYPE_DROPDOWN,
        REFERRED_BY_DROPDOWN,
        REFERRED_TO_DROPDOWN,
        REFERRAL_STATUS_DROPDOWN,
        HAS_NEW_CHANGES_CHECKBOX,
      ],
    },
  ];
}
